module.exports = __webpack_public_path__ + "static/media/project_demo.08f4f821.png";